import { useState, useEffect } from 'react';

interface StickyMobileCTAProps {
  onScrollTo: (id: string) => void;
}

export default function StickyMobileCTA({ onScrollTo }: StickyMobileCTAProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 lg:hidden transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}
    >
      <div className="bg-black border-t border-yellow-500/30 px-4 py-3 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-white text-xs font-bold truncate">Four Models — Campo Grande</p>
          <p className="text-yellow-500 text-[10px] font-semibold">19/04 • 14h ou 16h • Gratuito</p>
        </div>
        <button
          onClick={() => onScrollTo('inscricao')}
          className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-5 py-3 rounded-full text-xs font-black whitespace-nowrap hover:from-yellow-400 hover:to-yellow-500 transition-all duration-200 cursor-pointer flex-shrink-0"
        >
          👉 Garantir vaga
        </button>
      </div>
    </div>
  );
}
